/*The user object is the base type of all people who can access the system.
  A user can then be assigned a role as an employee etc but they need a user object to do so.
*/
class User {
    id;
    firstName;
    lastName;
    email;
    userType;
    from;
    to;
    constructor(jsonData) {
        this.id = jsonData.id || '',
            this.firstName = jsonData.firstName || '',
            this.lastName = jsonData.lastName || '',
            this.email = jsonData.email || '',
            this.userType = jsonData.userType || '';
        this.from = jsonData.from || '';
        this.to = jsonData.to || '';
    }
}
export default User;
